import { render } from "./ContactWidget.vue?vue&type=template&id=431a5e81&scoped=true"
import script from "./ContactWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactWidget.vue?vue&type=script&setup=true&lang=js"

import "./ContactWidget.vue?vue&type=style&index=0&id=431a5e81&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431a5e81"],['__file',"src/components/Utility/ContactWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "431a5e81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('431a5e81', __exports__)) {
    api.reload('431a5e81', __exports__)
  }
  
  module.hot.accept("./ContactWidget.vue?vue&type=template&id=431a5e81&scoped=true", () => {
    api.rerender('431a5e81', render)
  })

}


export default __exports__